import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class PostCaresDataTable {
  constructor() {
    $(document).ready(function() {
      showPostCaresTable();
    });

    $(document).on("turbo:render", function() {
      showPostCaresTable();
    });

    function showPostCaresTable() {
      $('#post-cares-datatable').dataTable({
        "order": [],
        "columnDefs": [ {
          "targets"  : 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#post-cares-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          {"data": "name"},
          {"data": "active"},
          {"data": "actions"}
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
